import {
  ADD_VIEW,
  GET_VIEW_BY_ID,
  GET_VIEW_NAMES,
  REMOVE_VIEW,
  SET_DEFAULT_VIEW,
  UPDATE_VIEW,
} from '@/rtk-query.gql';

import { enhancedApi } from '../api/baseApi';

export const customViewsApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    getViewNames: build.query({
      query: (variables) => ({
        document: GET_VIEW_NAMES,
        variables,
      }),
      providesTags: ['View'],
    }),
    getViewById: build.query({
      query: (variables) => ({
        document: GET_VIEW_BY_ID,
        variables,
      }),
    }),
    addView: build.mutation({
      query: (variables) => ({
        document: ADD_VIEW,
        variables,
      }),
      invalidatesTags: ['View'],
    }),
    removeView: build.mutation({
      query: (variables) => ({
        document: REMOVE_VIEW,
        variables,
      }),
      invalidatesTags: ['View'],
    }),
    updateView: build.mutation({
      query: (variables) => ({
        document: UPDATE_VIEW,
        variables,
      }),
      invalidatesTags: ['View'],
    }),
    defaultView: build.mutation({
      query: (variables) => ({
        document: SET_DEFAULT_VIEW,
        variables,
      }),
      invalidatesTags: ['View'],
    }),
  }),
});

export const {
  useGetViewNamesQuery,
  useGetViewByIdQuery,
  useAddViewMutation,
  useUpdateViewMutation,
  useRemoveViewMutation,
  useDefaultViewMutation,
} = customViewsApi;
